
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageCarousel, IFlexMessageTemplate } from '@/utils/types'
import SendingTestModal from '@/components/common/ui/SendingTestModal.vue'
import FlexMessageTemplateModal from '@/components/story/common/flex-message/FlexMessageTemplateModal.vue'
import FlexMessageJSONModal from '@/components/story/common/flex-message/FlexMessageJSONModal.vue'
import FlexMessageTemplateFormModal from '@/components/story/common/flex-message/FlexMessageTemplateFormModal.vue'

@Options({
  components: { FlexMessageTemplateFormModal, FlexMessageJSONModal, FlexMessageTemplateModal, SendingTestModal },
  directives: { maska },
  emits: ['update:modelValue', 'initMessage', 'onAddTemplate', 'update:altText'],
})
export default class TemplateButtons extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  isAdmin!: boolean

  @Prop()
  isSuper!: boolean

  @Prop()
  isChanged!: boolean

  @Prop()
  imgFile!: File

  @Prop()
  previewImageUrl!: string

  @Prop()
  altText!: string

  bubbleTemplate: IFlexMessageBubble = {
    type: 'bubble',
    body: {
      type: 'box',
      layout: 'vertical',
      contents: [],
    },
  }

  carouselTemplate: IFlexMessageCarousel = {
    type: 'carousel',
    contents: [
      {
        type: 'bubble',
        body: {
          type: 'box',
          layout: 'vertical',
          contents: [],
        },
      },
      {
        type: 'bubble',
        body: {
          type: 'box',
          layout: 'vertical',
          contents: [],
        },
      },
    ],
  }

  action = 'new'
  flexTemplateModalVisible = false
  flexJSONModalVisible = false
  sendingTestModalVisible = false

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  get selectedAppId() {
    return this.$route.params.app_id
  }

  onChangeAction(type, content = '') {
    this.action = type
    if (type === 'new') {
      if (content === 'bubble') {
        this.$emit('initMessage', this.bubbleTemplate)
      } else {
        this.$emit('initMessage', this.carouselTemplate)
      }
    } else if (type === 'template') {
      this.flexTemplateModalVisible = true
    } else if (type === 'json') {
      this.flexJSONModalVisible = true
    }
  }

  onSelectTemplate(template: IFlexMessageTemplate) {
    if (template.contents) {
      this.$emit('initMessage', template.contents)
      if (!this.altText && template.alt_text) {
        this.$emit('update:altText', template.alt_text)
      }
    }
    this.onCloseModal()
  }

  onCloseModal() {
    this.flexTemplateModalVisible = false
    this.flexJSONModalVisible = false
    this.sendingTestModalVisible = false
  }

  handleSendingTestModal() {
    this.sendingTestModalVisible = true
  }
}
